<template>
  <div
    id="login"
    style="background:url(https://index.cuican520.com/homeback.jpg); background-size: cover;width: 100%;height: 100%; background-position: center;overflow: hidden;"
  >
    <el-form
      :model="ruleForm2"
      :rules="rules2"
      ref="ruleForm2"
      label-position="left"
      label-width="0px"
      class="demo-ruleForm login-container"
    >
      <div style="text-align: center;margin-bottom: 20px;">
        <img style="width:80px;height:80px" src="https://index.cuican520.com/icon-40%403x.png" alt />
      </div>
      <h3 class="title" style=" text-align: center;margin-bottom: 30px;color:white;">
        <span>璀璨尊品APP后台上传</span>
      </h3>
      <el-form-item prop="account">
        <el-input
          type="text"
          v-model="ruleForm2.account"
          auto-complete="off"
          placeholder="账号"
          class="inputstyls"
        >
          <template slot="prepend">
            <img src="../../public/user.png" alt />
          </template>
        </el-input>
      </el-form-item>
      <el-form-item prop="checkPass">
        <el-input
          type="password"
          v-model="ruleForm2.checkPass"
          auto-complete="off"
          placeholder="密码"
          class="inputstyls"
          @keyup.native.enter="handleSubmit2"
        >
          <template slot="prepend">
            <img src="../../public/pwd.png" alt />
          </template>
        </el-input>
      </el-form-item>
      <el-form-item style="width:100%;">
        <el-button
          type="primary btnstyls"
          style="width:100% !important;"
          @click.native.prevent="handleSubmit2"
        >登 录</el-button>
      </el-form-item>
    </el-form>
  </div>
</template>
<script>
import { requestLogin } from '../api'
import qs from 'qs'
export default {
  name: 'login',
  data () {
    return {
      logining: false,
      ruleForm2: {
        account: '',
        checkPass: ''
      },
      rules2: {
        account: [
          {
            required: true,
            message: '请输入账号',
            trigger: 'blur'
          }
        ],
        checkPass: [
          { required: true, message: '请输入密码', trigger: 'blur' }
        ]
      },
      checked: true
    }
  },
  created () {
  },
  methods: {

    handleSubmit2 () {
      console.log(1111);
      this.logining = true
      var loginParams = qs.stringify({ 'loginName': this.ruleForm2.account, 'pwd': this.ruleForm2.checkPass })
      // console.log(loginParams)
      requestLogin(loginParams).then(data => {
        console.log('登陆成功：', data)
        this.logining = false
        let { code } = data
        if (code !== 10000) {
          this.$message({
            message: '用户名或者密码错误',
            type: 'error'
          })
        } else {
          sessionStorage.setItem('user', data.data.storeName)
          sessionStorage.setItem('roleCode', data.data.userId)
          sessionStorage.setItem('userId', data.data.userId)
          this.$router.push({ path: '/replenishmentList', query: { name: data } })
        }
      })
    },
  }
}
</script>

<style lang="stylus" scoped>
#login {
  .login__bg {
    img {
      width: 100%;
    }
  }

  .el-input-group__append, .el-input-group__prepend, border-right none, img {
    width: 16px;
  }

  input {
    border-left: none;
  }

  .el-input::-webkit-scrollbar-thumb {
    background-color: #fff;
  }

  .btnstyls {
    background-color: #000;
    border-color: #000;
  }
}

.login-container {
  -webkit-border-radius: 5px;
  border-radius: 5px;
  -moz-border-radius: 5px;
  background-clip: padding-box;
  margin: 0 auto;
  margin-top: 150px;
  width: 350px;
  padding: 35px 35px 15px 35px;
  background: rgba(17, 17, 19, 0.9);
  border-radius: 15px;
  box-shadow: 3px 3px 20px #000;
  height: 400px;
}

.el-form-item {
  margin-bottom: 40px;
}

.myfoot {
  width: 100%;
  // position absolute
  bottom: 20px;
  text-align: center;
  padding-bottom: 0;
}
</style>

